module.exports = __webpack_public_path__ + "img/fixed_btn.d59b5823.png";